import { render, staticRenderFns } from "./vListAdditionalCost.vue?vue&type=template&id=568dbe2e&scoped=true"
import script from "./vListAdditionalCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./vListAdditionalCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vListAdditionalCost.vue?vue&type=style&index=0&id=568dbe2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568dbe2e",
  null
  
)

export default component.exports